export default "__VITE_ASSET__Bu3diwKy__"